import { cva, type VariantProps } from "./style.utils";

export type ScrollAreaRootVariants = VariantProps<
  typeof scrollAreaRootVariants
>;

export const scrollAreaRootVariants = cva({
  base: "relative",
});

// -----------------------------------------------------------------------------

export type ScrollAreaViewportVariants = VariantProps<
  typeof scrollAreaViewportVariants
>;

export const scrollAreaViewportVariants = cva({
  base: [
    // layout
    "size-full",
    // radii/shadow
    "rounded-[inherit]",
    // animation
    "transition-[color,box-shadow]",
    // focus outline/border
    "outline-none",
    "focus-visible:outline-1 focus-visible:outline-offset-0",
    "focus-visible:ring-2 focus-visible:ring-ring-normal",
  ],
});

// -----------------------------------------------------------------------------

export type ScrollbarVariants = VariantProps<typeof scrollbarVariants>;

export const scrollbarVariants = cva({
  base: [
    // layout
    "flex p-1px",
    // foreground
    "touch-none select-none",
    // animation
    "transition-colors",
  ],
  variants: {
    orientation: {
      horizontal: "h-10px flex-col border-t border-t-transparent",
      vertical: "h-full w-10px border-l border-l-transparent",
    },
  },
  defaultVariants: {
    orientation: "vertical",
  },
});

export type ScrollBarThumbVariants = VariantProps<
  typeof scrollBarThumbVariants
>;

export const scrollBarThumbVariants = cva({
  base: [
    // layout
    "flex-1",
    // positioning
    "relative",
    // radii
    "rounded-full",
    // bockground
    "bg-shade-15",
  ],
});
